/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GuidanceType = {
    Hint: 'Hint',
    Warning: 'Warning',
    Critical: 'Critical'
} as const;
export type GuidanceType = typeof GuidanceType[keyof typeof GuidanceType];


export function GuidanceTypeFromJSON(json: any): GuidanceType {
    return GuidanceTypeFromJSONTyped(json, false);
}

export function GuidanceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuidanceType {
    return json as GuidanceType;
}

export function GuidanceTypeToJSON(value?: GuidanceType | null): any {
    return value as any;
}

